import { render } from "./teaWorkAgeSubjectEchart.vue?vue&type=template&id=4bdac227&scoped=true"
import script from "./teaWorkAgeSubjectEchart.vue?vue&type=script&lang=js"
export * from "./teaWorkAgeSubjectEchart.vue?vue&type=script&lang=js"

import "./teaWorkAgeSubjectEchart.vue?vue&type=style&index=0&id=4bdac227&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdac227"]])

export default __exports__